import { distributor, DISTRIBUTOR } from 'config';
import cathaymrRouting from 'distributor/cathaymr/routing';
import cathaymrConfigData from 'distributor/cathaymr/config-data';
import cathaymrMethods from 'distributor/cathaymr/methods';
import cpcpayRouting from 'distributor/cpcpay/routing';
import cpcpayConfigData from 'distributor/cpcpay/config-data';
import cpcpayMethods from 'distributor/cpcpay/methods';
import citimktRouting from 'distributor/citimkt/routing';
import citimktConfigData from 'distributor/citimkt/config-data';
import citimktMethods from 'distributor/citimkt/methods';
import linebankRouting from 'distributor/linebank/routing';
import linebankConfigData from 'distributor/linebank/config-data';
import linebankMethods from 'distributor/linebank/methods';
import iknow99Routing from 'distributor/iknow99/routing';
import iknow99ConfigData from 'distributor/iknow99/config-data';
import iknow99Methods from 'distributor/iknow99/methods';
import autopartnerRouting from 'distributor/autopartner/routing';
import autopartnerConfigData from 'distributor/autopartner/config-data';
import autopartnerMethods from 'distributor/autopartner/methods';
import npcRouting from 'distributor/npc/routing';
import npcConfigData from 'distributor/npc/config-data';
import npcMethods from 'distributor/npc/methods';
// testing UAT
import testRouting from 'distributor/test/routing';
import testConfigData from 'distributor/test/config-data';
import testMethods from 'distributor/test/methods';

const apps = {
  [DISTRIBUTOR.CATHAYMR]: {
    routing: cathaymrRouting,
    configData: cathaymrConfigData,
    methods: cathaymrMethods,
  },
  [DISTRIBUTOR.CPCPAY]: {
    routing: cpcpayRouting,
    configData: cpcpayConfigData,
    methods: cpcpayMethods,
  },
  [DISTRIBUTOR.CITIMKT]: {
    routing: citimktRouting,
    configData: citimktConfigData,
    methods: citimktMethods,
  },
  [DISTRIBUTOR.LINE_BANK]: {
    routing: linebankRouting,
    configData: linebankConfigData,
    methods: linebankMethods,
  },
  [DISTRIBUTOR.IKNOW99]: {
    routing: iknow99Routing,
    configData: iknow99ConfigData,
    methods: iknow99Methods,
  },
  [DISTRIBUTOR.AUTO_PARTNER]: {
    routing: autopartnerRouting,
    configData: autopartnerConfigData,
    methods: autopartnerMethods,
  },
  [DISTRIBUTOR.NPCPAY]: {
    routing: npcRouting,
    configData: npcConfigData,
    methods: npcMethods,
  },
  [DISTRIBUTOR.TEST]: {
    routing: testRouting,
    configData: testConfigData,
    methods: testMethods,
  },
};

export default apps[distributor()];
